<template>
  <div class="caseAssit">
    <div style="margin: 18px 0">
      <Breadcrumb :breadcrumb="breadcrumb" />
    </div>
    <a-row :gutter="10">
      <a-col :span="6">
        <div class="searchForm">
          <a-tree
            :tree-data="treeData"
            @select="onTreeSelect"
            showLine
            :expandedKeys.sync="defaultExpandedKeys"
            :defaultExpandParent="true"
          ></a-tree>
        </div>
      </a-col>
      <a-col :span="18">
        <div class="searchForm" style="margin-bottom: 10px">
          <Form ref="caseForm" :dataSource="getData" id="caseForm">
            <template v-slot:button>
              <div style="text-align: right; margin-top: 4px">
                <a-button type="primary" @click="search">查询</a-button>
                <a-button :style="{ marginLeft: '8px' }" @click="reset">重置</a-button>
              </div>
            </template>
          </Form>
        </div>
        <a-row v-if="divShow" class="searchForm" style="margin-bottom: 10px; padding: 10px 20px">
          <a-col :span="12" style="font-size: 14px">{{ treeSelectData.title }}</a-col>
          <a-col :span="12" style="text-align: right">
            <a @click="showModal">修改权限</a>
            <a style="margin-left: 10px" @click="increaseItem">新增用户</a>
          </a-col>
          <a-col :span="24" style="margin-top: 5px; padding-left: 20px; color: #6797eb">
            <a-icon type="environment" style="margin-right: 5px" />
            <span style="margin-right: 10px"></span>
            <a-icon type="phone" style="margin-right: 5px" />
            <span></span>
          </a-col>
        </a-row>
        <!--        <div class="increase" style="padding:32px 0 10px 0;position: relative;min-height:74px">-->
        <!--          <a-button type="primary" @click="increaseItem" style="position: absolute;top:32px;left:0;">-->
        <!--            新增-->
        <!--          </a-button>-->
        <!--        </div>-->
        <div class="table" style="background: #fff; border-radius: 2px">
          <a-table
            :columns="columns"
            :data-source="data"
            @change="changePage"
            :loading="loading"
            :pagination="pagination"
            :rowKey="
              (record) => {
                record.user_id
              }
            "
          >
            <span slot="name" slot-scope="text, data1, index">{{ index + 1 }}</span>
            <span slot="action" slot-scope="text, data2">
              <a @click="show(data2)">查看</a>
              <a-divider type="vertical" />
              <a @click="edit(data2)">编辑</a>
              <a-divider type="vertical" />
              <a
                @click="defaultPerson(data2)"
              >{{ data2.is_default_deal_person === 1 ? '取消默认人' : '设为默认人' }}</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确定删除?" ok-text="是" cancel-text="否" @confirm="deleteAssit(data2)">
                <a>删除</a>
              </a-popconfirm>
            </span>
          </a-table>
        </div>
      </a-col>
    </a-row>
    <a-modal title="修改权限" :visible="visible" @ok="handleOk" @cancel="handleCancel" width="800px">
      <a-checkbox-group
        @change="onCheck"
        v-model="checkedValues"
        :defaultChecked="defaultChecked"
        style="width: 100%"
      >
        <a-row>
          <div class="title" style="overflow: hidden; margin-bottom: 10px">
            <div class="titleColor"></div>
            <div class="titleText">综合帮扶</div>
          </div>
          <a-col :span="6">
            <a-checkbox value="aggregate" class="topCheck">帮扶数据汇总</a-checkbox>
          </a-col>
          <a-col :span="6">
            <a-checkbox value="caseAssit" class="topCheck">个案帮扶</a-checkbox>
            <a-checkbox value="caseAssit_new" class="bottomCheck">新增</a-checkbox>
          </a-col>
          <a-col :span="6">
            <a-checkbox value="itemAssit" class="topCheck">项目帮扶</a-checkbox>
            <a-checkbox value="itemAssit_new" class="bottomCheck">新增</a-checkbox>
          </a-col>
          <!-- <a-col :span="6">
            <a-checkbox value="giveMe" class="topCheck"> 帮侬一把 </a-checkbox>
            <a-checkbox value="giveMe_new" class="bottomCheck"> 新增 </a-checkbox>
          </a-col>-->
        </a-row>
        <a-row style="margin-top: 10px">
          <div class="title" style="overflow: hidden; margin-bottom: 10px">
            <div class="titleColor"></div>
            <div class="titleText">帮扶对象</div>
          </div>
          <a-col :span="6">
            <a-checkbox value="assitTarget" class="topCheck">帮扶对象</a-checkbox>
            <a-checkbox value="assitTarget_new" class="bottomCheck">新增</a-checkbox>
          </a-col>
        </a-row>
        <!-- <a-row style="margin-top: 10px">
          <div class="title" style="overflow: hidden; margin-bottom: 10px">
            <div class="titleColor"></div>
            <div class="titleText">资金发放</div>
          </div>
          <a-col :span="6">
            <a-checkbox value="fundMange" class="topCheck"> 资金管理 </a-checkbox>
          </a-col>
          <a-col :span="6">
            <a-checkbox value="sendMange" class="topCheck"> 发放管理 </a-checkbox>
          </a-col>
        </a-row>-->
        <a-row style="margin-top: 10px">
          <div class="title" style="overflow: hidden; margin-bottom: 10px">
            <div class="titleColor"></div>
            <div class="titleText">内容管理</div>
          </div>
          <a-col :span="6">
            <a-checkbox value="contentMange" class="topCheck">文件管理</a-checkbox>
          </a-col>
          <a-col :span="6">
            <a-checkbox value="reportPush" class="topCheck">公告发布</a-checkbox>
          </a-col>
        </a-row>
        <a-row style="margin-top: 10px">
          <div class="title" style="overflow: hidden; margin-bottom: 10px">
            <div class="titleColor"></div>
            <div class="titleText">综合查询</div>
          </div>
          <a-col :span="6">
            <a-checkbox value="comprehensiveQuery" class="topCheck">综合查询</a-checkbox>
          </a-col>
        </a-row>
        <a-row style="margin-top: 10px">
          <div class="title" style="overflow: hidden; margin-bottom: 10px">
            <div class="titleColor"></div>
            <div class="titleText">系统成员</div>
          </div>
          <a-col :span="6">
            <a-checkbox value="systemPerson" class="topCheck">系统成员管理</a-checkbox>
          </a-col>
          <a-col :span="6">
            <a-checkbox value="volunteerMange" class="topCheck">志愿者管理</a-checkbox>
          </a-col>
        </a-row>
      </a-checkbox-group>
    </a-modal>
  </div>
</template>

<script>
import Form from '@/components/GlobalForm'
import Breadcrumb from '@/components/breadcrumb'
import { forms } from './formData'
import { service } from './service'
import { checkIdCard } from '@/utils/checkFun'
import _ from 'lodash'
import request from '@/utils/request'
import { message } from 'ant-design-vue'
const columns = [
  {
    title: '编号',
    dataIndex: 'num',
    key: 'num',
    width: 60,
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '登录账号',
    dataIndex: 'user_name',
    key: 'user_name',
    ellipsis: true
  },
  {
    title: '姓名',
    dataIndex: 'user_nick_name',
    key: 'user_nick_name',
    ellipsis: true
  },
  {
    title: '所属部门',
    dataIndex: 'municipal_tree_name',
    key: 'municipal_tree_name',
    ellipsis: true
  },
  // {
  //   title: '备注',
  //   dataIndex: 'user_company',
  //   key: 'user_company'
  // },
  // {
  //   title: '管理项目',
  //   dataIndex: 'user_belongs_project',
  //   key: 'user_belongs_project',
  //   ellipsis: true
  // },
  {
    title: '操作',
    key: 'action',
    width: 240,
    fixed: 'right',
    scopedSlots: { customRender: 'action' }
  }
]
export default {
  name: 'Index',
  components: {
    Breadcrumb,
    Form
  },
  data() {
    return {
      gData: [
        {
          title: '街道',
          key: '1'
        },
        {
          title: '区县',
          key: '2'
        },
        {
          title: '基金会',
          key: '3'
        }
      ],
      municipal_tree_id: '1', // 选中的树节点
      columns,
      isShow: false, // 身份证号输入框是否展示
      divShow: false,
      inputNumber: '',
      params: {},
      data: [], // 列表数据
      activeData: [], // 活动帮扶
      pagination: {
        // 分页
        current: 1,
        pageSize: 12,
        total: 0,
        showTotal: (total) => `共 ${total} 条数据`
      },
      treeData: [], // 树数据
      treeSelectData: { key: '', title: '' }, // 树选中的数据
      ModalText: 'Content of the modal',
      visible: false,
      checkedValues: [], // 选中的值
      defaultChecked: [], // 默认选中的
      defaultExpandedKeys: [],
      breadcrumb: [
        {
          title: '系统成员',
          path: ''
        },
        {
          title: '系统成员管理',
          path: ''
        }
      ],
      loading: false
    } // 面包屑
  },
  computed: {
    // 获取查询的form表单
    getData() {
      return forms.getFormData({}, this)
    },
    getIdCard() {
      return forms.getIdCard(this)
    }
  },
  mounted() {
    service.municipalTree().then((response) => {
      this.treeData = response
      this.defaultExpandedKeys = [this.treeData[0].value]
    })
  },
  methods: {
    /**
     * check点击
     */
    onCheck(checkedValues) {
      // this.checkedValues = checkedValues
      // console.log(this.checkedValues)
    },
    /**
     * 弹出框展示
     */
    showModal() {
      this.visible = true
      service.getMunicipalTreeById({ id: this.treeSelectData.key }).then((res) => {
        this.defaultChecked = res.remark1
        this.checkedValues = res.remark1
      })
    },
    /**
     * 弹出框确认
     */
    handleOk(e) {
      const params = {}
      params.remark1 = this.checkedValues
      params.id = this.treeSelectData.key
      service.updateMunicipalTreeById(params)
      this.defaultChecked = []
      this.checkedValues = []
      this.visible = false
    },
    /**
     * 弹出框取消
     */
    handleCancel(e) {
      this.defaultChecked = []
      this.checkedValues = []
      this.visible = false
    },
    /**
     * 当树点击时
     */
    onTreeSelect(selectData) {
      this.divShow = true
      this.treeSelectData = this.findTreeData(selectData[0])
      this.needHelpPerson({
        pageIndex: 1,
        pageSize: this.pagination.pageSize,
        municipal_tree_id: selectData[0]
      }) // 查帮扶人员数据列表
    },
    /**
     * 循环寻找指定树id的全部数据
     * @param treeId string 树Id
     */
    findTreeData(treeId) {
      const td = _.cloneDeep(this.treeData)
      for (let i = 0; i < td.length; i++) {
        if (td[i].key === treeId) {
          return td[i]
        }
        if (td[i].children.length > 0) {
          for (let j = 0; j < td[i].children.length; j++) {
            if (td[i].children[j].key === treeId) {
              return td[i].children[j]
            }
            if (td[i].children[j].children.length > 0) {
              for (let k = 0; k < td[i].children[j].children.length; k++) {
                if (td[i].children[j].children[k].key === treeId) {
                  return td[i].children[j].children[k]
                }
              }
            }
          }
        }
      }
    },
    // 分页切换
    changePage(pagination) {
      this.pagination.current = pagination.current
      this.needHelpPerson({
        pageIndex: pagination.current,
        pageSize: this.pagination.pageSize,
        ...this.params
      }) // 查帮扶人员数据列表
    },
    // 查询
    search() {
      let params = {}
      params = this.$refs.caseForm.getFieldsValue()
      this.pagination.current = 1
      this.params = params
      this.needHelpPerson({ pageIndex: 1, pageSize: this.pagination.pageSize, ...params }) // 查帮扶人员数据列表
    },
    // 重置
    reset() {
      this.$refs.caseForm.resetFields()
    },
    // 新增项目,帮扶申请
    increaseItem() {
      this.$router.push({
        path: '/assit/systemPerson/increaseMember',
        query: {
          pageType: 'increase',
          treeId: this.treeSelectData.key,
          treeLevel: this.treeSelectData.level,
          treeTitle: this.treeSelectData.title
        }
      })
    },
    // 数字输入框
    numberChange(value, id) {
      let newValue = value
      newValue = newValue.replace(/[^\d]/g, '') // 清除“数字”和“.”以外的字符
      newValue = newValue.replace(/^\./g, '') // 验证第一个字符是数字而不是.
      newValue = newValue.replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的.
      newValue = newValue
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
      setTimeout(() => {
        this.$refs.caseForm.setFieldsValue(id, newValue)
      }, 10)
    },
    // 校验身份证号是否合法
    checkIdCard(rule, value, callback) {
      // const form = this.$refs.caseForm
      if (value && !checkIdCard(value)) {
        const title = '请输入正确的身份证号'
        callback(title)
      } else {
        callback()
      }
    },
    // 获取帮扶人员数据列表
    needHelpPerson(data) {
      this.loading = true
      this.data = []
      service.userForPage(data).then((response) => {
        this.data = response.data || []
        this.pagination.total = response.total || 0
        this.loading = false
      })
    },
    // 帮扶人员信息编辑
    edit(record) {
      const params = {
        user_id: record.user_id
      }
      this.$router.push({
        path: '/assit/systemPerson/increaseMember',
        query: { pageType: 'edit', processData: JSON.stringify(params) }
      })
    },
    // 设为默认人
    async defaultPerson(item) {
      this.loading = true
      if (item.is_default_deal_person === 0) {
        request({
          url: `/auth/online/checkDefaultUser`,
          method: 'get',
          params: { municipalTreeId: item.municipal_tree_id }
        }).then((ret) => {
          if (ret) {
            message.error('已设置了其他默认人,请勿重复设置')
          } else {
            item.is_default_deal_person = 1
            service.updateUser({ ...item }).then((response) => {
              this.loading = false
              this.$notification.success({
                message: '设置成功'
              })
              this.$router.push({ path: '/assit/systemPerson/member' })
            })
          }
        })

        // alert(JSON.stringify(item))
      } else {
        item.is_default_deal_person = 0
        await service.updateUser({ ...item }).then((response) => {
          this.loading = false
          this.$notification.success({
            message: '取消成功'
          })
          this.$router.push({ path: '/assit/systemPerson/member' })
        })
      }
      this.loading = false
    },
    // 删除帮扶人员信息
    deleteAssit(record) {
      service.delUser({ user_id: record.user_id }).then((response) => {
        this.$notification.success({
          message: '删除成功'
        })
        this.pagination.current = 1
        this.needHelpPerson({
          pageIndex: 1,
          municipal_tree_id: this.treeSelectData.key,
          pageSize: this.pagination.pageSize,
          ...this.params
        }) // 查帮扶人员数据列表
        // this.needHelpPerson({})// 查帮扶人员数据列表
      })
    },
    getType(value, type) {
      if (type === 'area') {
        if (value && value.length > 0 && value[0].value === '-1') {
          return true
        }
      }
      if (type === 'street') {
        if (value && value.length > 0 && value[0].value === '-2') {
          return true
        }
      }
      if (type === 'fund') {
        if (value && value.length > 0 && value[0].value === '0') {
          return true
        }
      }
      return false
    },
    getValue(value) {
      let data = ''
      if (value && value.length === 1) {
        data = value[0].label
      }
      if (value && value.length > 1) {
        for (let i = 1; i < value.length; i++) {
          data = data + value[i].label
        }
      }
      return data
    },
    // 节点选中事件
    onSelect(data) {
      this.municipal_tree_id = data
      this.needHelpPerson({ municipal_tree_id: this.municipal_tree_id }) // 查帮扶人员数据列表
    },
    show(record) {
      // 根据流程类型判断跳到哪个界面
      const params = {
        user_id: record.user_id
      }
      this.$router.push({
        path: '/assit/systemPerson/increaseMember',
        query: { pageType: 'view', processData: JSON.stringify(params) }
      })
    }
  }
}
</script>

<style scoped lang="less">
@import "../../style.less";
.caseAssit {
  .searchForm {
    background: #fff;
    padding: 24px 20px 11px;
    /*margin:24px 0 11px 0;*/
  }
}
.topCheck {
  width: 100%;
}
.bottomCheck {
  margin: 5px 0 0 0;
}
.titleColor {
  margin-top: 3px;
  width: 4px;
  height: 16px;
  background: #3d73dd;
  margin-right: 9px;
  float: left;
}
.titleText {
  float: left;
  font-size: 14px;
  font-family: PingFangSC-Medium;
  color: #1c2d51;
  font-weight: 600;
  line-height: 20px;
}
</style>
